// extracted by mini-css-extract-plugin
export default {"icon":"extra-actions_icon__7yhe5","menuItem":"extra-actions_menuItem__qSGZJ"};